import { api } from '@/lib/axios';

export interface SystemSetting {
  id: string;
  key: string;
  value: string;
  description?: string;
  encrypted: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreateSettingDto {
  key: string;
  value: string;
  description?: string;
  encrypted?: boolean;
}

export interface UpdateSettingDto {
  value: string;
  description?: string;
}

export const settingsService = {
  async getAll(): Promise<SystemSetting[]> {
    const response = await api.get<SystemSetting[]>('/settings');
    return response.data;
  },

  async getByKey(key: string): Promise<SystemSetting> {
    const response = await api.get<SystemSetting>(`/settings/${key}`);
    return response.data;
  },

  async create(data: CreateSettingDto): Promise<SystemSetting> {
    const response = await api.post<SystemSetting>('/settings', data);
    return response.data;
  },

  async update(key: string, data: UpdateSettingDto): Promise<SystemSetting> {
    const response = await api.put<SystemSetting>(`/settings/${key}`, data);
    return response.data;
  },

  async delete(key: string): Promise<void> {
    await api.delete(`/settings/${key}`);
  },

  // WhatsApp Agent Settings
  async getWhatsAppAgentSettings(): Promise<WhatsAppAgentSettings> {
    const response = await api.get<WhatsAppAgentSettings>('/settings/whatsapp-agent');
    return response.data;
  },

  async updateWhatsAppAgentSettings(data: WhatsAppAgentSettingsDto): Promise<WhatsAppAgentSettings> {
    const response = await api.put<WhatsAppAgentSettings>('/settings/whatsapp-agent', data);
    return response.data;
  },

  // Integrations
  async updateIntegrations(data: UpdateIntegrationsDto): Promise<void> {
    await api.put('/settings/integrations', data);
  },
};

export interface WhatsAppAgentSettings {
  enabled: boolean;
  startTime: string;
  endTime: string;
  daysOfWeek: number[];
}

export interface WhatsAppAgentSettingsDto {
  enabled?: boolean;
  startTime?: string;
  endTime?: string;
  daysOfWeek?: number[];
}

export interface UpdateIntegrationsDto {
  whatsapp?: {
    evolutionApiUrl?: string;
    evolutionApiKey?: string;
    evolutionInstance?: string;
    whatsappEnabled?: boolean;
  };
}
